
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function MasterAdminSignup() {
  const navigate = useNavigate();

  // SEO Meta Tags
  useEffect(() => {
    document.title = 'Master Admin Signup | System Registration - Taskbudy';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Master administrator registration for Taskbudy platform management.');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = 'Master administrator registration for Taskbudy platform management.';
      document.head.appendChild(meta);
    }

    const metaRobots = document.querySelector('meta[name="robots"]');
    if (metaRobots) {
      metaRobots.setAttribute('content', 'noindex, nofollow');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'robots';
      meta.content = 'noindex, nofollow';
      document.head.appendChild(meta);
    }
  }, []);

  return (
    <>
      <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-black">
        {/* Navigation */}
        <nav className="bg-black/50 backdrop-blur-sm shadow-lg sticky top-0 z-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex justify-between items-center h-16">
              <div 
                className="flex items-center space-x-2 cursor-pointer transform hover:scale-105 transition-transform duration-300"
                onClick={() => navigate('/')}
              >
                <img 
                  src="https://static.readdy.ai/image/a3382d87126fc476a032aa8f5ebcbb38/ef22cd57bb320b669eb4db4ff59ba9cf.png" 
                  alt="Taskbudy" 
                  className="h-8 md:h-12"
                />
              </div>

              <button
                onClick={() => navigate('/auth/master-admin-login')}
                className="px-6 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-all duration-300 whitespace-nowrap cursor-pointer transform hover:scale-105 hover:shadow-lg"
              >
                Master Admin Login
              </button>
            </div>
          </div>
        </nav>

        <div className="min-h-screen flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
          <div className="max-w-md w-full">
            {/* Header */}
            <div className="text-center mb-8">
              <div className="flex items-center justify-center mb-4">
                <div className="w-20 h-20 bg-gradient-to-br from-red-600 to-orange-600 rounded-2xl flex items-center justify-center shadow-2xl">
                  <i className="ri-shield-star-line text-4xl text-white"></i>
                </div>
              </div>
              <h2 className="text-4xl font-bold text-white mb-2">Registration Disabled</h2>
              <p className="text-gray-400">Public admin registration is not available</p>
            </div>

            {/* Info Card */}
            <div className="bg-gray-800/50 backdrop-blur-sm rounded-2xl shadow-2xl p-8 border border-gray-700">
              <div className="text-center space-y-6">
                <div className="w-16 h-16 bg-amber-900/30 rounded-full flex items-center justify-center mx-auto">
                  <i className="ri-lock-line text-3xl text-amber-400"></i>
                </div>
                
                <div>
                  <h3 className="text-xl font-semibold text-white mb-2">Admin Access Restricted</h3>
                  <p className="text-gray-400 text-sm leading-relaxed">
                    New administrator accounts can only be created by the Super Admin through the Admin Dashboard.
                  </p>
                </div>

                <div className="p-4 bg-gray-900/50 rounded-xl border border-gray-700">
                  <p className="text-sm text-gray-300">
                    <i className="ri-information-line text-amber-400 mr-2"></i>
                    If you need admin access, please contact the Super Admin directly.
                  </p>
                </div>

                <div className="pt-4 space-y-3">
                  <button
                    onClick={() => navigate('/auth/master-admin-login')}
                    className="w-full bg-gradient-to-r from-red-600 to-orange-600 text-white py-3 px-6 rounded-xl font-semibold hover:from-red-700 hover:to-orange-700 transition-all duration-200 whitespace-nowrap shadow-lg cursor-pointer"
                  >
                    Go to Admin Login
                  </button>
                  
                  <button
                    onClick={() => navigate('/')}
                    className="w-full bg-gray-700 text-white py-3 px-6 rounded-xl font-semibold hover:bg-gray-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
                  >
                    Return to Homepage
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
